module.exports = __webpack_public_path__ + "static/media/menu-gold.5a12c27e.svg";